import { createSlice } from "@reduxjs/toolkit";

// Define the initial state for the userProjectDetailsSlice
const initialState = {
  loading: false,
  success: false,
  hasData: false,
  errorMessage: "",
  error: false,
  data: {
    ProjectDetails:[]
  },
};

// Create the userProjectDetailsSlice using createSlice
const userProjectDetailsSlice = createSlice({
  name: "userProjectDetails", // Slice name
  initialState, // Initial state
  reducers: {
    fetchUserProjectDetails(state, action) {
      state.loading = true;
      state.success = false;
      state.data = initialState.data;
      state.errorMessage = "";
      
      state.error = false;
      state.hasData = false;
    },

    fetchUserProjectDetailsSuccess(state, action) {
      state.loading = false;
      state.success = true;
      state.data = action.payload ?? {};
      state.errorMessage = "";
      state.error = false;
      state.hasData = true;
    },

    fetchUserProjectDetailsFailure(state, action) {
      state.loading = false;
      state.success = false;
      state.data = initialState.data;
      state.errorMessage = action.payload ?? "something went wrong";
      state.error = true;
      state.hasData = false;
    },
      updateUserProjectDetails(state, action) {
        state.data = { ...state.data, ProjectDetails: action?.payload?.ProjectDetails || [] };
    },
  },
});

// Export the reducer functions as actions
export const {
  fetchUserProjectDetails,
  fetchUserProjectDetailsSuccess,
  fetchUserProjectDetailsFailure,
  updateUserProjectDetails
} = userProjectDetailsSlice.actions;
// Export the reducer function itself
export default userProjectDetailsSlice.reducer;
